import Maps from "./ClassMaps"
import 'url-change-event'

const map = document.querySelector('.cpt_map .map')
const switcher = document.getElementById('switchView')
const listingCards = document.querySelector('.listing-cards')
const pagination = document.querySelector('.page-pagination')
const cpt = listingCards.dataset['cpt'] ?? ''

let ID = map.getAttribute('id')
let lng = map.getAttribute('data-long')
let lat = map.getAttribute('data-lat')
let zoom = map.getAttribute('data-zoom')
let loader = map.closest('.wrapper_map').querySelector('.loader')

let firstInit = false
/*From URL*/
let urlQuery = window.location.search
let params = new URLSearchParams(urlQuery)
let Map = ''


let view = params.get('view')

if(view === 'map'){
    map.closest('.cpt_map').classList.replace('hide', 'show')
    listingCards.style.display = 'none'
    pagination.style.display = 'none'
    switcher.setAttribute('data-view', 'map')
    switcher.setAttribute('title', 'Afficher la liste')
    switcher.querySelector('.js-view__title').innerHTML = 'Afficher la liste'
    switcher.querySelector('svg use').setAttribute('xlink:href','#ic-misc-list')

    Map = new Maps(ID, lng, lat, zoom, loader)
    Map.init
    Map.mapParams.cpt = cpt
    Map.apiParams = Object.fromEntries(params)
    Map.addMarkers('', '', '', cpt)

    firstInit = true
}

// Init the Map
switcher.addEventListener('click', function(){
    if(map.closest('.cpt_map').classList.contains('hide')){

        map.closest('.cpt_map').classList.replace('hide', 'show')
        listingCards.style.display = 'none'
        pagination.style.display = 'none'
        this.setAttribute('data-view', 'map')
        this.setAttribute('title', 'Afficher la liste')
        this.querySelector('.js-view__title').innerHTML = 'Afficher la liste'
        this.querySelector('svg use').setAttribute('xlink:href','#ic-misc-list')

        if(!firstInit){
            Map = new Maps(ID, lng, lat, zoom, loader)
            Map.init
            Map.mapParams.cpt = cpt
        }

        let urlParams = new URLSearchParams(window.location.search)
        urlParams.set('view', 'map')
        window.history.pushState('', '', '?' + urlParams.toString())

        firstInit = true
    }
    else{
        map.closest('.cpt_map').classList.replace('show', 'hide')
        listingCards.style.display = 'flex'
        if(listingCards.classList.contains('listing-cards--v1')){
            listingCards.style.display = 'block'
        }
        pagination.style.display = 'block'
        this.querySelector('.js-view__title').innerHTML = 'Afficher le plan'
        this.setAttribute('data-view', 'list')
        this.setAttribute('title', 'Afficher la plan')
        this.querySelector('svg use').setAttribute('xlink:href','#ic-misc-location')

        let urlParams = new URLSearchParams(window.location.search)
        urlParams.delete('view')
        window.history.pushState('', '', '?' + urlParams.toString())
    }

})

window.addEventListener('urlchangeevent', function(event) {
    queryMaps(Map, event.newURL)
})

function queryMaps(Map, newURL){
    if (newURL.searchParams.get('view') === 'map') {
        Map.resetCPTMarkers()
        Map.apiParams = Object.fromEntries(newURL.searchParams)
        Map.addMarkers('', '', '', cpt)
    }
}


function requireAll(r) {
    r.keys().forEach(r);
}

requireAll(require.context('../../', true, /\.(png|jpe?g|gif|svg)$/));



